export const API_BASE_URL = 'https://pokeapi.co/api/v2/';
